/**
 * @generated SignedSource<<fa1688bcc4da010eaf48dca8887608cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DefaultRoleSection_person$data = {
  readonly contracts: ReadonlyArray<{
    readonly end_date: string | null | undefined;
    readonly id: number;
    readonly role: {
      readonly id: number;
      readonly name: string;
    };
    readonly start_date: string | null | undefined;
  }>;
  readonly id: number;
  readonly " $fragmentType": "DefaultRoleSection_person";
};
export type DefaultRoleSection_person$key = {
  readonly " $data"?: DefaultRoleSection_person$data;
  readonly " $fragmentSpreads": FragmentRefs<"DefaultRoleSection_person">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DefaultRoleSection_person",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "contracts",
      "kind": "LinkedField",
      "name": "contracts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "start_date",
          "args": null,
          "kind": "ScalarField",
          "name": "start_date_runn",
          "storageKey": null
        },
        {
          "alias": "end_date",
          "args": null,
          "kind": "ScalarField",
          "name": "end_date_runn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "roles",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "people",
  "abstractKey": null
};
})();

(node as any).hash = "4a9e7e6d51a14bd9b06f1638beac2a1e";

export default node;
